import {
  Component,
  OnInit,
  ViewChild,
  Input,
  SimpleChanges,
} from "@angular/core";
import { NotifierService } from "src/app/_services/notifier.service";
// import { FilterByTagsComponent } from "../../filterByTags/filterbytags.component";
import { Subscription } from "rxjs";
import * as Models from "../../charges/chargesbyservice/service-charges.model";
import { Router, ActivatedRoute, NavigationEnd, Params } from "@angular/router";
import { ServiceService } from "../../charges/chargesbyservice/chargeser.service";
import { take } from "rxjs/operators";
import { Model } from "echarts";
export type SortableColumn =
  | "product_code"
  | "final_cost"
  | "base_cost"
  | "usage";
type BreakpointKey = "region" | "product_family" | "line_item";
@Component({
  selector: "app-charges-by-account",
  templateUrl: "./chargesbyaccount.component.html",
  styleUrls: ["./chargesbyaccount.component.css"],
})
export class ChargesByAccountComponent implements OnInit {
  // @ViewChild(FilterByTagsComponent) filterComponent!: FilterByTagsComponent;
  accountOptions: { id: number; name: string }[] = [];
  selectedAccountIds: any = [];
  @Input() monthYear: any;
  @Input() accountId: any;
  @Input() regionId: any;

  breakpoints = {
    region: false,
    product_family: false,
    line_item: false,
  };
  gear: boolean = false;
  currentPage = 1;
  pageSizeOptions = [5, 10, 15];
  filterTags = false;
  headers: Models.Header[] = [
    { key: "product_code", label: "Service Name", sortable: true },
    { key: "usage", label: "Usage", sortable: false },
    { key: "base_cost", label: "Public Cost (USD)", sortable: true },
    { key: "final_cost", label: "Final Cost (USD)", sortable: true },
  ];

  accounts: Models.Accounts[] = [];
  sortKey: Models.SortableColumn = "product_code";
  searchTerm = "";
  filter = "";
  sortDirection: "asc" | "desc" = "asc";
  isExpandedAll = false;
  totactiveser: any;
  filteredList: Models.Accounts[] = [];
  funRef: any = {};
  currentMessage!: Subscription;
  total: any;
  filteredTag: { accountId: string; tagKey: string; tagValue: string } | null =
    null;
  selectedPageSize = 5;
  wrapLines = false;
  usagePagination = false;
  visibleColumns: any;
  preferencesData: {
    pageSize: number;
    wrapLines: boolean;
    usagePagination: boolean;
    visibleColumns: {
      description: boolean;
      usageQuantity: boolean;
      amountUsd: boolean;
    };
    breakpoints: {
      region: boolean;
      product_family: boolean;
      line_item: boolean;
    };
    selectedAccountIds: string[];
  } = {
    pageSize: 5,
    wrapLines: false,
    usagePagination: true,
    visibleColumns: {
      description: true,
      usageQuantity: true,
      amountUsd: true,
    },
    breakpoints: {
      region: false,
      product_family: false,
      line_item: false,
    },
    selectedAccountIds: [],
  };

  constructor(
    public notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ServiceService
  ) {}

  ngOnInit(): void {
    const { options, ids: accountIds } = this.loadAccountsFromStorage();
    this.accountOptions = options;

    const navigation = this.router.getCurrentNavigation();

    if (!navigation || !navigation.extras?.state) {
      this.route.queryParams.pipe(take(1)).subscribe((params: Params) => {
        const breakupParam = params["breakup"];

        // Reset all breakpoints
        this.preferencesData = this.getDefaultPreferences();
        Object.keys(this.preferencesData.breakpoints).forEach((k) => {
          this.preferencesData.breakpoints[
            k as keyof typeof this.preferencesData.breakpoints
          ] = false;
        });

        // Enable specific breakpoints if breakup is present
        if (breakupParam) {
          const breakupKeys = breakupParam.split(",");
          breakupKeys.forEach((key: any) => {
            if (key in this.preferencesData.breakpoints) {
              this.preferencesData.breakpoints[
                key as keyof typeof this.preferencesData.breakpoints
              ] = true;
            }
          });
        }

        if (!("open" in params)) {
          if (Object.keys(params).length > 0) {
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {},
              replaceUrl: true,
            });
          }

          this.load();
          return;
        }

        const { open, ...filteredParams } = params as Record<string, any>;
        const [month, year] = this.monthYear.split("-");
        filteredParams["month"] = month;
        filteredParams["year"] = year;

        filteredParams["account_ids"] = accountIds.join(",");

        setTimeout(() => {
          this.loadPreferences(filteredParams);
        }, 100);
      });
    } else {
      this.load();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changedLater = (key: "monthYear" | "accountId"): boolean =>
      !!changes[key] && !changes[key].isFirstChange();

    if (changedLater("monthYear") || changedLater("accountId")) {
      this.preferencesData = this.getDefaultPreferences();

      this.load();
    }
  }

  private buildQueryParams(): Record<string, any> {
    const { ids: accountIds } = this.loadAccountsFromStorage();
    const [month, year] = this.monthYear.split("-");

    const params: Record<string, any> = {
      account_ids: accountIds.join(","), // send as string
      year,
      month,
    };

    // Include tag filters if present
    const hasTagFilters =
      this.filteredTag?.tagKey && this.filteredTag?.tagValue;
    if (hasTagFilters) {
      params.tag_key = this.filteredTag!.tagKey;
      params.tag_value = this.filteredTag!.tagValue;
    }

    const activeBreakups = Object.entries(this.breakpoints)
      .filter(([_, isEnabled]) => isEnabled)
      .map(([key]) => key);

    if (activeBreakups.length) {
      params.breakup = activeBreakups.join(",");
    }
    return params;
  }

  clearPreferences(): void {
    this.breakpoints = {
      region: false,
      product_family: false,
      line_item: false,
    };
    this.preferencesData.breakpoints = { ...this.breakpoints };
    // Reload data without breakpoints
    this.load();
  }

  private async fetchAccountsData(params: Record<string, any>): Promise<any> {
    params["type"] = "all_account_monthly";
    this.notifier.loading(true);
    const { result } = await this.service.loadData(params);
    setTimeout(() => {
      this.notifier.loading(false);
    }, 4000);

    return result || {};
  }

  private processAccountsResponse(response: any): void {
    // Reset arrays at the start for a fresh single-response render.
    // If you want to append across multiple responses, see note below.
    this.accounts = [];
    this.filteredList = [];

    const accountsList = Array.isArray(response?.response?.accounts)
      ? response.response.accounts
      : [];
    this.total = response?.all_account_cost_summary?.final_cost || 0;

    // Iterate and PUSH each processed account (do NOT overwrite this.accounts inside the loop)
    accountsList.forEach((acc: any, idx: number) => {
      // Grab current_month entries (do NOT fallback to previous_month here per your rule)
      const awsCurrent = acc.aws?.current_month?.[0] ?? null;
      const mpCurrent = acc.marketplace?.current_month?.[0] ?? null;

      // Skip the account entirely if both are missing in current_month
      if (!awsCurrent && !mpCurrent) {
        return; // continue to next account
      }

      // Build normalized account object for the UI
      const accountEntry: any = {
        account_id: acc.account_id,
        base_cost: acc.base_cost || 0,
        final_cost: acc.final_cost || 0,
        expanded: false, // account-level toggle
        aws: awsCurrent
          ? {
              base_cost: awsCurrent.base_cost || 0,
              final_cost: awsCurrent.final_cost || 0,
              services: Array.isArray(awsCurrent.services)
                ? awsCurrent.services
                : [],
            }
          : null,
        marketplace: mpCurrent
          ? {
              base_cost: mpCurrent.base_cost || 0,
              final_cost: mpCurrent.final_cost || 0,
              services: Array.isArray(mpCurrent.services)
                ? mpCurrent.services
                : [],
            }
          : null,
      };

      // IMPORTANT: push into the array (append) — this is the correct place to push
      this.accounts.push(accountEntry);
    });

    // Bind to filteredList for the template
    this.filteredList = [...this.accounts];
  }

  onSubmitClick(): void {
    // Copy current checkbox selections into preferencesData
    this.preferencesData.breakpoints = { ...this.breakpoints };

    // Then call load, which will include breakpoints in params
    this.load();
  }

  private loadAccountsFromStorage(): {
    options: { id: number; name: string }[];
    ids: string[];
  } {
    const stored = localStorage.getItem("accountIdData");
    let options: { id: number; name: string }[] = [];
    let ids: string[] = [];

    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const list = parsed.list || [];
        options = list.map((item: any) => ({
          id: item.accountId,
          name: `${item.accountName} (${item.accountId})`,
        }));
        ids = list.map((item: any) => item.accountId);
      } catch (err) {
        console.error("Error parsing accountIdData from localStorage", err);
      }
    }

    return { options, ids };
  }

  async load(): Promise<void> {
    this.notifier.loading(true);
    this.preferencesData = this.getDefaultPreferences();

    const { options } = this.loadAccountsFromStorage();
    this.accountOptions = options;

    // 👇 Build single combined API request for all accounts
    const params = this.buildQueryParams();

    try {
      const response = await this.fetchAccountsData(params);

      this.processAccountsResponse(response);

      // maintain URL param state
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { open: "chargeacc" },
        queryParamsHandling: "",
      });
    } catch (error) {
      console.error("❌ Load error:", error);
      this.accounts = [];
      this.filteredList = [];
    } finally {
      this.notifier.loading(false);
    }
  }

  private buildFilteredParams(filteredQuery: any): Record<string, any> {
    const { mode, ...queryWithoutMode } = filteredQuery;
    // queryWithoutMode.type = 'all_account_monthly'
    return queryWithoutMode;
  }

  private async fetchAndProcessFilteredData(
    params: Record<string, any>
  ): Promise<void> {
    params["type"] = "all_account_monthly";
    const { result } = await this.service.loadData(params);
    const response = result || {};
    this.total = response.response.all_account_cost_summary?.final_cost;
    this.totactiveser = response.response.accounts?.length || 0;
    this.processAccountsResponse(response);
  }

  async loadPreferences(filteredQuery: any): Promise<void> {
    this.notifier.loading(true);

    this.filteredTag =
      filteredQuery?.mode === "filter"
        ? {
            accountId: filteredQuery.account_ids,
            tagKey: filteredQuery.tag_key,
            tagValue: filteredQuery.tag_value,
          }
        : null;

    if (this.filteredList.length === 0) {
      try {
        const queryWithoutMode = this.buildFilteredParams(filteredQuery);

        // Ensure 'month' is present in the query
        if (!("month" in queryWithoutMode) && this.monthYear) {
          queryWithoutMode.month = this.monthYear;
        }
        // queryWithoutMode.type = 'all_account_monthly'
        await this.fetchAndProcessFilteredData(queryWithoutMode);
      } catch (error) {
        console.error("Load error:", error);
        this.accounts = [];
        this.filteredList = [];
      }
    }

    this.notifier.loading(false);
  }

  handlePreferencesResponse(data: any) {
    this.gear = false;
    this.isExpandedAll = false;
    const prefs = data.preferences ?? {};
    this.preferencesData = prefs;
    this.selectedPageSize = prefs.pageSize ?? this.selectedPageSize;
    this.wrapLines = prefs.wrapLines ?? this.wrapLines;
    this.usagePagination = prefs.usagePagination ?? this.usagePagination;
    this.visibleColumns = prefs.visibleColumns ?? this.visibleColumns;
    this.breakpoints = prefs.breakpoints ?? this.breakpoints;
    this.selectedAccountIds = prefs.selectedAccountIds ?? [];

    if (data.accounts) {
      this.accounts = data.accounts;
      this.addExpandedFlagToServices(data.accounts || []);
      this.filteredList = [...this.accounts];
    }
    if (data.all_account_cost_summary) {
      this.total = data.all_account_cost_summary.final_cost;
    }

    if (this.filteredTag) {
      this.load();
    }

    this.currentPage = 1;
  }

  get totalPages(): number {
    return Math.ceil(this.filteredList.length / this.selectedPageSize);
  }

  get paginatedList(): Models.Accounts[] {
    if (!this.filteredList || !Array.isArray(this.filteredList)) {
      return [];
    }
    const start = (this.currentPage - 1) * this.selectedPageSize;
    const end = start + this.selectedPageSize;
    return this.filteredList.slice(start, end);
  }

  private getBreakpointDelay(): number {
    const delayMap: Record<"region" | "product_family" | "line_item", number> =
      {
        region: 350,
        product_family: 1200,
        line_item: 2000,
      };

    const activeKeys = Object.keys(this.breakpoints).filter(
      (key) => this.breakpoints[key as keyof typeof delayMap]
    ) as (keyof typeof delayMap)[];

    const lastActiveKey = activeKeys[activeKeys.length - 1];

    return lastActiveKey ? delayMap[lastActiveKey] : 0;
  }

  async goToPreviousPage(): Promise<void> {
    this.notifier.loading(true);
    if (this.isExpandedAll) {
      const delay = this.getBreakpointDelay();
      if (delay > 0) {
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
    if (this.currentPage > 1) {
      this.currentPage--;
    }

    this.notifier.loading(false);
  }

  async goToNextPage(): Promise<void> {
    this.notifier.loading(true);

    if (this.isExpandedAll) {
      const delay = this.getBreakpointDelay();
      if (delay > 0) {
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }

    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }

    this.notifier.loading(false);
  }

  toggle(item: any) {
    item.expanded = !item.expanded;
  }

  private setExpandedDeep(account: Models.Accounts, expanded: boolean): void {
    account.expanded = expanded;

    // 🔹 AWS Section
    if (account.aws) {
      account.aws.expanded = expanded;

      account.aws.services?.forEach((service: any) => {
        service.expanded = expanded;

        service.regions?.forEach((region: any) => {
          region.expanded = expanded;

          region.product_families?.forEach((pf: any) => {
            pf.expanded = expanded;

            pf.operations?.forEach((op: any) => {
              op.expanded = expanded;

              op.line_items?.forEach((li: any) => {
                li.expanded = expanded; // optional, if you track expansion for line items
              });
            });
          });
        });
      });
    }

    // 🔹 Marketplace Section
    if (account.marketplace) {
      account.marketplace.expanded = expanded;

      account.marketplace.services?.forEach((service: any) => {
        service.expanded = expanded;

        service.regions?.forEach((region: any) => {
          region.expanded = expanded;

          region.product_families?.forEach((pf: any) => {
            pf.expanded = expanded;

            pf.operations?.forEach((op: any) => {
              op.expanded = expanded;

              op.line_items?.forEach((li: any) => {
                li.expanded = expanded;
              });
            });
          });
        });
      });
    }
  }
  async toggleExpandAll(): Promise<void> {
    this.notifier.loading(true);
    await new Promise((resolve) => setTimeout(resolve, 200));

    this.isExpandedAll = !this.isExpandedAll;

    this.accounts.forEach((account) => {
      this.setExpandedDeep(account, this.isExpandedAll);
    });

    this.notifier.loading(false);
  }

  onTagsFiltered(event: any) {
    this.filteredTag = event;
  }

  onSearch(): void {
    const term = String(this.searchTerm ?? "")
      .trim()
      .toLowerCase();

    this.filteredList = !term
      ? [...this.accounts]
      : this.accounts.filter((acc) => {
          // 1️⃣ Check account_id
          if ((acc.account_id ?? "").toLowerCase().includes(term)) return true;

          // 2️⃣ Check AWS services
          const awsMatch = acc.aws?.services?.some((service) =>
            (service.product_name ?? service.product_code ?? "")
              .toLowerCase()
              .includes(term)
          );
          if (awsMatch) return true;

          // 3️⃣ Check Marketplace services
          const mpMatch = acc.marketplace?.services?.some((service) =>
            (service.product_name ?? service.product_code ?? "")
              .toLowerCase()
              .includes(term)
          );
          if (mpMatch) return true;

          return false;
        });

    this.currentPage = 1;
  }

  addExpandedFlagToServices(accounts: any[]): any[] {
    const toArray = (val: any): any[] => (Array.isArray(val) ? val : []);

    return accounts.map((account) => {
      const acc = { ...account, expanded: false };

      acc.services = toArray(acc.services).map((service) => {
        const s = { ...service, expanded: false };

        s.regions = toArray(s.regions).map((region) => {
          const r = { ...region, expanded: false };

          r.product_families = toArray(r.product_families).map((pf) => {
            const p = { ...pf, expanded: false };

            p.operations = toArray(p.operations).map((op) => {
              const o = { ...op, expanded: false };

              o.line_items = toArray(op.line_items);
              return o;
            });

            return p;
          });

          return r;
        });

        return s;
      });

      return acc;
    });
  }

  private getDefaultPreferences(): any {
    return {
      pageSize: 5,
      wrapLines: false,
      usagePagination: true,
      visibleColumns: {
        description: true,
        usageQuantity: true,
        amountUsd: true,
      },
      breakpoints: {
        region: false,
        product_family: false,
        line_item: false,
      },
      selectedAccountIds: [],
    };
  }

  trackByAccountId(index: number, item: Models.Accounts): string {
    return item.account_id;
  }

  ngOnDestroy(): void {
    if (this.currentMessage) {
      this.currentMessage.unsubscribe();
    }
  }
}
